import Button from '@app/components/common/Button';
import Icon from '@app/components/common/Icon';
import { MQ_MAX_LARGE } from '@app/theme/types';
import { useState } from 'react';
import { WithTranslation } from 'react-i18next';
import EmailReportModal from '../EmailReportModal';
import { TCsx } from '@emotion/react';

interface IEmailReportButton extends WithTranslation {
  isLoading: boolean;
  isDisabled: boolean;
  csx?: TCsx;
}

const EmailReportButton = ({
  t,
  isLoading,
  isDisabled,
  csx = {},
}: IEmailReportButton) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  return (
    <>
      <EmailReportModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setIsSendingEmail={setIsSendingEmail}
      />
      <Button
        csx={[
          {
            width: 174,
            [MQ_MAX_LARGE]: {
              width: 60,
              '> span.icon.icon-left': {
                paddingRight: '0px',
                position: 'relative',
              },
            },
          },
          csx,
        ]}
        icon={<Icon name="MdOutlineEmail" />}
        variant="secondary"
        onClick={() => setIsModalOpen(true)}
        isLoading={isLoading || isSendingEmail}
        disabled={isDisabled || isSendingEmail}>
        <span
          css={{
            [MQ_MAX_LARGE]: {
              display: 'none',
            },
          }}>
          {t('commonTexts.email')}
        </span>
      </Button>
    </>
  );
};

export default EmailReportButton;
